import React from 'react';
import styles from './style.css';

class MenuTitle extends React.Component {
  render() {
    const { menuTitle, subTitle, column, additionalClassName } = this.props;
    const columnNumber = column === undefined ? '6' : column;

    return (
      <div
        className={`hidden-xs hidden-sm col-md-${columnNumber} ${
          styles['menu-title']
        } ${styles[menuTitle.toLowerCase().replace(/[\W_]+/g, '-')]} ${
          styles[additionalClassName]
        }`}
      >
        <h2>{menuTitle}</h2>
        {subTitle && <h4> {subTitle} </h4>}
      </div>
    );
  }
}

export default MenuTitle;
